export default "__VITE_ASSET__od7UYBc2__"